import React, { useEffect } from "react";
import "./App.css";
import Navbar from "./Components/Navbar";
import HomePage from "./Pages/HomePage";
import AboutMe from "./Pages/AboutMe";
import Experience from "./Pages/Experience";
import Botttombar from "./Pages/Botttombar";
import Testimonials from "./Pages/Testimonials";
import Skills from "./Pages/Skills";
import Projects from "./Pages/Projects";
import EmailMe from "./Components/EmailMe";
import BackToTopButton from "./Components/backToTopButton";
import Bubble from "./Components/Bubble";

function App() {
  useEffect(() => {
    EmailMe();
  }, []);

  return (
    <div className="App">
      {/* <Bubble /> */}
      <Navbar />

      <HomePage />
      <AboutMe />
      <Skills />
      <Projects />
      <Experience />
      <Testimonials />
      <Botttombar />
      <BackToTopButton />
    </div>
  );
}

export default App;
